import React from 'react';
import './css/CategoryBox.css';
import { formatProfileTag } from '../../shared/utils/function';
import { useNavigation } from '../../shared/utils/useNavigation';

const CategoryBox = ({
    category,
    index,
}) => {
    const navigate = useNavigation();
    const handleCategoryClick = (categoryName) => {
        navigate.toAllCreators(categoryName);
    };

    return (
        <div
            className="category-box hover-lift"
            onClick={() => handleCategoryClick(category.name)}
            style={{ animationDelay: `${index * 0.05}s` }}
        >
            <div className="category-box-overlay"></div>
            <div className="category-box-glow"></div>
            <div className="category-box-content">
                <span className="category-box-name">
                    {formatProfileTag(category.name)}
                </span>
                <span className="category-box-count">
                    {category.count} {category.count > 1 ? 'creators' : 'creator'}
                </span>
            </div>
        </div>
    );
};

export default CategoryBox;

